import loadable from '@loadable/component';
import React from 'react';
import { useLayout } from './hooks/layout.hooks';
import layoutProps from './layoutProps';

const layouts = {
  default: loadable(
    () => import(/* webpackChunkName: "layout-default" */ './Default/DefaultLayout'),
  ),
  animated: loadable(
    () => import(/* webpackChunkName: "layout-default" */ './AnimatedLayout/AnimatedLayout'),
  ),
  'video-background': loadable(
    () =>
      import(
        /* webpackChunkName: "layout-video-background" */ './VideoBackground/VideoBackgroundLayout'
      ),
  ),
};

const Layout = (props) => {
  const layout = useLayout();
  const Renderer = layouts[layout?.type] || layouts.default;

  return <Renderer {...props} />;
};

Layout.propTypes = layoutProps;

export default Layout;
